import React, { useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { connect } from 'react-redux';

import 'emoji-mart/css/emoji-mart.css';

import * as UserAction from '../../../actions/User.actions';
import { LINKS_FORM } from '../../../constants/FormNames';
import { ValidationTypes } from '../../../enums/ValidationTypes';
import Button from '../../Button';
import '../../../styles/components/options/popups/AddLink.scss';
import TextInput from '../../TextInput';

const AddLink = ({ type, name, onHanleSuccess, formData, uploadImgLinks }) => {
	const [isActive, setActive] = useState(false);

	function handleSwitch(e) {
		if (e.target.attributes.id.value === 'emoji') {
			setActive(true);
			return;
		}
		setActive(false);
	}

	const fileTypes = ['JPG', 'PNG', 'GIF'];

	const [file, setFile] = useState(null);
	const handleChange = file => {
		setFile(file);
	};

	const handleSave = () => {
		uploadImgLinks(
			{
				icon: file,
				url: formData?.url,
				title: formData?.title,
			},
			sus => {
				console.log(sus);
				onHanleSuccess();
			},

			err => {
				console.log(err);
			}
		);
	};

	const [imageUrl, setImageUrl] = useState(null);
	const handleImageUrl = e => {
		const url = e.target.value;
		if (url.trim().lenght === 0) setImageUrl(null);
		setImageUrl(url);
	};

	return (
		<div className='AddLinkWrapper'>
			<span className='title'>Select an icon</span>
			<div className='icon-wrapper'>
				<div className='icon-select-container'>
					<div className='menubar'>
						<div className='switch'>
							<span onClick={e => handleSwitch(e)} id='image'>
								Upload an image
							</span>
						</div>
						<div className='switch'>
							<span onClick={e => handleSwitch(e)} id='emoji'>
								URL
							</span>
						</div>
					</div>
					<div className='box-wrapper'>
						<div className={isActive ? 'icons-container active' : 'icons-container'}>
							<div className='box_inside'>
								<FileUploader
									handleChange={handleChange}
									name='file'
									types={fileTypes}
									label='Upload or drop a file right here'
									maxSize={1} //file size in MB
								/>
							</div>
							<div className='box_inside'>
								<div className='image-url-container'>
									<textarea
										className='image-url-input'
										placeholder='Enter image URL Here'
										onKeyUp={e => handleImageUrl(e)}
									/>
									<div className='image-preview'>
										{imageUrl && <img src={imageUrl} alt='' />}
										{!imageUrl && <span>Preview</span>}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<TextInput
				type={type}
				id={'url'}
				placeholder={'url'}
				form={LINKS_FORM}
				value={formData?.url}
				name={'url'}
				validations={[ValidationTypes.required]}
				hidden={false}
				rightSideIcon={null}
				mainIcon={null}
			/>
			<TextInput
				type={type}
				id={'title'}
				placeholder={'title'}
				form={LINKS_FORM}
				value={formData?.title}
				name={'title'}
				validations={[ValidationTypes.required]}
				hidden={false}
				rightSideIcon={null}
				mainIcon={null}
			/>
			<div className='button-wrapper'>
				<Button
					active
					className='save-button'
					labal='Add'
					onClickEvent={() => handleSave()}
				></Button>
			</div>
		</div>
	);
};

const mapStateToProps = ({ forms }) => ({
	formData: forms?.[LINKS_FORM]?.values || {},
});

const mapDispatchToProps = {
	uploadImgLinks: UserAction.uploadImgLinks,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddLink);
